export default "__VITE_ASSET__DnyY0Cvz__"